import React from 'react';
import { Box, Container, Typography, Grid, Link, IconButton } from '@mui/material';
import { 
  LocationOn as LocationIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon
} from '@mui/icons-material';
import logo from '../assets/images/logo_foot.jpg';
const quickLinks = [
  { name: 'Home', href: '/' },
  { name: 'About Us', href: '/aboutus' },
  { name: 'Courses', href: '/courses' },
  { name: 'Knowledge', href: '/knowledge' },
  { name: 'Contact', href: '/contact' }
];

const courseLinks = [
  { name: 'Business Chinese', href: '/business-chinese' },
  { name: 'Exam Preparation', href: '/exam-preparation' },
  { name: 'Speech & Eloquence', href: '/speech-eloquence' },
  { name: 'Immersion Programs', href: '/immersion-programs' },
  { name: 'Tailored Programs', href: '/courses#tailored-programs' }
];

const socialLinks = [
  { icon: <FacebookIcon />, href: 'https://www.facebook.com/share/17M1wfyPkc/', label: 'Facebook' },
  { icon: <InstagramIcon />, href: '/', label: 'Instagram' },
  { icon: <TwitterIcon />, href: '/', label: 'Twitter' },
  { icon: <LinkedInIcon />, href: '/', label: 'LinkedIn' }
];

function Footer() {
  return (
    <Box
      sx={{
        bgcolor: '#1a1a2e',
        color: 'white',
        pt: 8,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(7, 40, 75, 0.1) 0%, rgba(41, 33, 159, 0.05) 100%)',
          zIndex: 1,
          pointerEvents: 'none'
        }
      }}
    >
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2, px: { xs: 2, md: 4 } }}>
        
        {/* Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, height: { xs: '100px', md: '185px' } }}>
            <img src={logo} alt="Logo" style={{ width: 'auto', objectFit: 'cover', height: '100%' }} />
        </Box>
        {/* 主要内容区域 */}
        <Grid container spacing={6} sx={{ mb: 6 }}>
          {/* 左侧 - Logo和联系信息 */}
          <Grid item xs={12} md={6}>
            <Box>

              {/* 地址和联系方式 */}
              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                  <LocationIcon sx={{ mr: 2, mt: 0.5, color: '#9f2122', fontSize: '1.2rem' }} />
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'rgba(255, 255, 255, 0.9)',
                        lineHeight: 1.6,
                        fontSize: '1rem'
                      }}
                    >
                      10 Anson Road #35-02A International Plaza, Singapore 079903
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <PhoneIcon sx={{ mr: 2, color: '#9f2122', fontSize: '1.2rem' }} />
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'rgba(255, 255, 255, 0.9)',
                      fontSize: '1rem'
                    }}
                  >
                    +65 89208197
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
                  <EmailIcon sx={{ mr: 2, color: '#9f2122', fontSize: '1.2rem' }} />
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'rgba(255, 255, 255, 0.9)',
                      fontSize: '1rem'
                    }}
                  >
                    info@chihuimandarin.com
                  </Typography>
                </Box>
              </Box>

              {/* 社交媒体 */}
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'white',
                    fontWeight: 600,
                    mb: 2,
                    fontSize: '1.1rem'
                  }}
                >
                  Follow Us
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  {socialLinks.map((social, index) => (
                    <IconButton
                      key={index}
                      href={social.href}
                      target="_blank"
                      sx={{
                        bgcolor: 'rgba(159, 33, 34, 0.2)',
                        color: '#9f2122',
                        border: '1px solid rgba(159, 33, 34, 0.3)',
                        '&:hover': {
                          bgcolor: '#9f2122',
                          color: 'white',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(159, 33, 34, 0.3)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                      aria-label={social.label}
                    >
                      {social.icon}
                    </IconButton>
                  ))}
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* 右侧 - 网站链接列表 */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {/* 快速链接 */}
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'white',
                    fontWeight: 600,
                    mb: 3,
                    fontSize: '1.1rem'
                  }}
                >
                  Quick Links
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {quickLinks.map((link, index) => (
                    <Link
                      key={index}
                      href={link.href}
                      sx={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        textDecoration: 'none',
                        fontSize: '0.95rem',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          color: '#9f2122',
                          textDecoration: 'underline',
                          transform: 'translateX(4px)'
                        }
                      }}
                    >
                      {link.name}
                    </Link>
                  ))}
                </Box>
              </Grid>

              {/* 课程链接 */}
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'white',
                    fontWeight: 600,
                    mb: 3,
                    fontSize: '1.1rem'
                  }}
                >
                  Our Courses
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {courseLinks.map((link, index) => (
                    <Link
                      key={index}
                      href={link.href}
                      sx={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        textDecoration: 'none',
                        fontSize: '0.95rem',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          color: '#9f2122',
                          textDecoration: 'underline',
                          transform: 'translateX(4px)'
                        }
                      }}
                    >
                      {link.name}
                    </Link>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

      </Container>
      
        {/* 分隔线 */}
        <Box
          sx={{
            width: '100%',
            height: '1px',
            bgcolor: 'rgba(255, 255, 255, 0.1)',
            mb: 3
          }}
        />

        {/* Copyright */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '0.9rem',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1
            }}
          >
            <span>© 2025 CHIHUI Mandarin Hub. All rights reserved.</span>
            <span>|</span>
            <a
              href="/privacy-policy.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#9f2122';
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'rgba(255, 255, 255, 0.7)';
                e.target.style.textDecoration = 'none';
              }}
            >
              Privacy Policy
            </a>
            <span>|</span>
            <a
              href="/terms-conditions.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#9f2122';
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'rgba(255, 255, 255, 0.7)';
                e.target.style.textDecoration = 'none';
              }}
            >
              Terms & Conditions
            </a>
            <span>|</span>
            <a
              href="/cookie-policy.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#9f2122';
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'rgba(255, 255, 255, 0.7)';
                e.target.style.textDecoration = 'none';
              }}
            >
              Cookie Policy
            </a>
          </Box>
        </Box>
    </Box>
  );
}

export default Footer;
